<template>
  <Wrapper id="sidebar-design-mobile" v-if="siteComponents" class="p-gd-2 h-100">
    <Overlay></Overlay>
  </Wrapper>
</template>

<script>
import { mapGetters } from "vuex";
import Overlay from "./Overlay/Overlay";
import {
  Wrapper,
} from "./SidebarDesign.styled";

export default {
  components: {
    Wrapper,
    Overlay
  },
  data() {
    return {
      
    };
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      elHoverID: "design/component/elHoverID",
      CONTENT_CONTAINER: "design/metadata/CONTENT_CONTAINER",
      components: "design/metadata/components",
      pageName: "design/page/pageName",
      sitePageID: "design/metadata/sitePageID",
      siteMainPageID: "design/metadata/siteMainPageID",
      siteComponents: "design/metadata/siteComponents",
    }),

    
  },
  methods: {
    
  },
  mounted() {},
};
</script>

<style>
:root {
  --sidebar-width: 344px;
}
</style>